import { Component, OnInit, ViewChild, ElementRef, Output, EventEmitter, Input } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { scrollTopChange } from 'src/app/utilities/utilities.file';
import { SharedServiceService } from 'src/app/services/shared-service.service';
import { DataCapture } from 'src/app/model/data-capture';
import { CompleteApplicationService } from 'src/app/services/complete-application.service';
import { IwService } from 'src/app/services/iw.service';
import { CompleteApplicationData } from 'src/app/model/complete-application';
import { VALIDATION_MSG, GENERIC_ERRORS } from 'src/app/config/app-settings.config';
import { ThemeService } from 'src/app/services/theme.service';
declare var AmoScript: Function;
declare var form_next_click: Function;
declare var _satellite: any;

@Component({
  selector: 'app-additional-details',
  templateUrl: './additional-details.component.html',
  styleUrls: ['./additional-details.component.scss']
})
export class AdditionalDetailsComponent implements OnInit {

  additionalForm: FormGroup;
  @ViewChild('matAdditionalBlock') additionalBlock: ElementRef;
  qdeResponse: any;
  additionalDetails = new DataCapture();
  eapplyFormPostQDELabel: any;
  caData: any;
  qdeInitialData: any;
  airIndiaCardList = ['AISU', 'AIPU', 'EGPU', 'EGSU'];
  showAirIndiaField = false;
  @Output() additionalDetailsSectionValid = new EventEmitter<any>();
  @Input() expandedAdd: any;
  percentageAdd: any = "0%";
  trackCkyStatus: any;
  saveUpdateSuccess: any;
  saveUpdateError: any;
  validation_msg: any;
  generic_error: any;
  partnerCode: any = sessionStorage.getItem('partner-code');
  containerType: any = sessionStorage.getItem('container-type');
  expandAddDetails: any;
  fromSWIFTJourney: boolean;


  constructor(
    private fb: FormBuilder, 
    private sharedService: SharedServiceService, 
    private completeApp: CompleteApplicationService, 
    private iw: IwService,
    private themeService: ThemeService
    ){
      this.partnerCode = this.themeService.partnerCode;
     }

  ngOnInit() {
    this.fromSWIFTJourney = this.sharedService.fromSwiftJourney;
    this.validation_msg = VALIDATION_MSG;
    this.generic_error = GENERIC_ERRORS;
    this.createForm();
    this.qdeResponse = this.sharedService.qdeSuccessResponse;
    this.qdeInitialData = this.sharedService.qdeSubmitData;
    if (this.airIndiaCardList.includes(this.qdeInitialData ? this.qdeInitialData.WSCallCardType.toUpperCase() : '')) {
      this.showAirIndiaField = true;
    } else {
      this.showAirIndiaField = false;
    }
    this.eapplyFormPostQDELabel = this.iw.geteapplyFormPostQDEDCR();
    this.additionalForm.valueChanges.subscribe(v => {
      this.savePartialData();
    })
    this.patchDetailsForTracking()
    this.setPercentageAdditional();
    this.getExpandStatus();
  }

  createForm() {
    this.additionalForm = this.fb.group({
      fcnAmaid: [''],
      fcnFrequentflyer: [''],
      fcnCkycno: ['']
    })
  }

  public hasError = (controlName: string, errorName: string) => {
    return this.additionalForm.controls[controlName].hasError(errorName);
  }

  get f() {
    return this.additionalForm.controls;
  }

  scrollTopChangeAdditional() {
    scrollTopChange(this.additionalBlock);
  }

  numberOnly(event) {
    let regex2 = /[0-9]/;
    if (event.key.match(regex2)) {
      return true;
    } else {
      return false;
    }
  }

  savePartialData() {
    let labelsDisplay: any;
    if (this.eapplyFormPostQDELabel) {
      if (this.eapplyFormPostQDELabel.amaId && this.eapplyFormPostQDELabel.amaId.ama_label) {
        labelsDisplay = this.eapplyFormPostQDELabel.amaId.ama_label
      } if (this.eapplyFormPostQDELabel.frequentFlyer && this.eapplyFormPostQDELabel.frequentFlyer.ff_label) {
        labelsDisplay = labelsDisplay + "|" + this.eapplyFormPostQDELabel.frequentFlyer.ff_label
      } if (this.eapplyFormPostQDELabel.ckycNumber_text && this.eapplyFormPostQDELabel.ckycNumber_text.ckycNumber_label) {
        labelsDisplay = labelsDisplay + "|" + this.eapplyFormPostQDELabel.ckycNumber_text.ckycNumber_label
      }
    }
    this.additionalDetails.amaId = this.f.fcnAmaid ? this.f.fcnAmaid.value : '';
    this.additionalDetails.frequentFlyer = this.f.fcnFrequentflyer ? this.f.fcnFrequentflyer.value : '';
    this.additionalDetails.ckycNumber = this.f.fcnCkycno ? this.f.fcnCkycno.value : '';
    this.completeApp.additionalData = this.additionalDetails;
    this.additionalDetailsSectionValid.emit({ 'addValid': this.additionalForm.valid, additionalSectionVisible: ((this.qdeInitialData && this.qdeInitialData.WSCallCardType == 'DCIU') || this.showAirIndiaField || (this.qdeResponse && this.qdeResponse.ckycStatus.toLowerCase() == 'success')) });
  }

  setApplicationData() {
    this.caData = new CompleteApplicationData();
    this.caData.WSCallUserAmaId = this.f.fcnAmaid ? this.f.fcnAmaid.value : '';
    this.caData.WSCallUserFrequentFlyer = this.f.fcnFrequentflyer ? this.f.fcnFrequentflyer.value : '';
    this.caData.WSCallUserCkycNumber = this.f.fcnCkycno ? this.f.fcnCkycno.value : '';
    // this.caData.WSCallUserApplicationNumber = this.sharedService.trackApplicationResponse ? this.sharedService.trackApplicationResponse.applicationNumber : (this.sharedService.qdeSuccessResponse && this.sharedService.qdeSuccessResponse.applicationNumber ? this.sharedService.qdeSuccessResponse.applicationNumber : '');
    this.sharedService.cAadditionalData = this.caData;
    let reqObj = Object.assign({}, this.sharedService.qdeSubmitData, this.caData, this.sharedService.cAprofessisonalData, this.sharedService.cApersonalData,this.sharedService.cAadditionalCardFeatureData);
    this.completeApp.saveUpdateApplication(reqObj).subscribe((result: any) => {
      if (result) {
        if (result.DataCaptureRes && result.DataCaptureRes.WSCallStatus && result.DataCaptureRes.WSCallStatus.toLowerCase() === 'success') {
          this.sharedService.dcSeqId = result.DataCaptureRes.WSCallSequenceId;
          this.saveUpdateSuccess = true;

        } else {
          this.saveUpdateSuccess = false;
          this.saveUpdateError = this.generic_error.genError;
        }
      } else {
        this.saveUpdateSuccess = false;
        this.saveUpdateError = this.generic_error.genError;
        window["digitalData"].error = { message: this.saveUpdateError };
        if(window['_satellite']){
          _satellite.track('form_error');
        }
      }
    }, (error) => {
      this.saveUpdateSuccess = false;
      this.saveUpdateError = this.generic_error.genError;
    })
  }

  setPercentageAdditional() {
    this.percentageAdd = "100%"
  }

  patchDetailsForTracking() {
    if (this.sharedService.trackApplicationResponse) {
      if(this.fromSWIFTJourney){
        console.log("trying to autopopulate from patchDetailsForTracking in additional details");
      }
      else {
        console.log("trying to autopopulate else from patchDetailsForTracking in additional details");
        this.additionalForm.patchValue({
          fcnAmaid: this.sharedService.trackApplicationResponse.eapplyApplicantDetails && this.sharedService.trackApplicationResponse.eapplyApplicantDetails.amaId ? this.sharedService.trackApplicationResponse.eapplyApplicantDetails.amaId : '',
          fcnFrequentflyer: this.sharedService.trackApplicationResponse.eapplyPersonalDetails && this.sharedService.trackApplicationResponse.eapplyPersonalDetails.ffNo ? this.sharedService.trackApplicationResponse.eapplyPersonalDetails.ffNo : '',
          fcnCkycno: this.sharedService.trackApplicationResponse.eapplyApplicantDetails && this.sharedService.trackApplicationResponse.eapplyApplicantDetails.kycNo ? this.sharedService.trackApplicationResponse.eapplyApplicantDetails.kycNo : ''
        })
        this.trackCkyStatus = this.sharedService.trackApplicationResponse.eapplyApplicantDetails && this.sharedService.trackApplicationResponse.eapplyApplicantDetails.ckycStatus;
      }
    }
  }

  getExpandStatus(){
    this.sharedService.openAddDetailsObservable.subscribe((status: any)=>{
      console.log('steps',status.expand, status.step);
      
      this.expandAddDetails = status.step;
    })
  }
}
